module.exports = __webpack_public_path__ + "static/img/stay-option-icon-shampoo.534798fa.svg";